var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeHeader"},[_c('div',{staticClass:"homeHeaderTitle"}),_c('div',{staticClass:"homeHeaderHandles"},[_c('div',{staticClass:"homeHeaderTeleportHandles"},[_vm._t("default")],2),_c('otherBackstage'),_c('userAvatarCard')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }